import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';

function AdminReferrals() {
  const navigate = useNavigate();
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddForm, setShowAddForm] = useState(false);
  const [newAgent, setNewAgent] = useState({ name: '', email: '', referralCode: '', notes: '', country: 'India' });
  const [error, setError] = useState('');
  const [daysFilter, setDaysFilter] = useState('');

  useEffect(() => {
    fetchStats();
  }, [daysFilter]);

  const fetchStats = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const params = daysFilter ? `?days=${daysFilter}` : '';
      const res = await axios.get(`/api/referrals/stats${params}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAgents(res.data);
    } catch (err) {
      console.error('Failed to fetch referral stats:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleAddAgent = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const token = localStorage.getItem('accessToken');
      await axios.post('/api/referrals/agents', newAgent, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setNewAgent({ name: '', email: '', referralCode: '', notes: '' });
      setShowAddForm(false);
      fetchStats();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to create agent');
    }
  };

  const handleToggleActive = async (agentId, currentActive) => {
    try {
      const token = localStorage.getItem('accessToken');
      await axios.put(`/api/referrals/agents/${agentId}`, { is_active: !currentActive }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchStats();
    } catch (err) {
      console.error('Failed to toggle agent:', err);
    }
  };

  const siteUrl = window.location.origin;

  // Totals
  const totals = agents.reduce((acc, a) => ({
    signups: acc.signups + a.total_signups,
    activated: acc.activated + a.activated_users,
    posted: acc.posted + a.users_with_posts,
    retained: acc.retained + a.retained_7d_users,
  }), { signups: 0, activated: 0, posted: 0, retained: 0 });

  return (
    <div>
      <Navbar />
      <div className="container" style={{ maxWidth: '900px', margin: '0 auto' }}>
        <button className="btn" onClick={() => navigate('/dashboard')} style={{ marginBottom: '16px', background: 'none', color: '#6b7280', border: '1px solid #e5e7eb', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer' }}>
          ← Back
        </button>

        <div className="card">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
            <h2 style={{ margin: 0 }}>📊 Referral Attribution</h2>
            <button
              onClick={() => setShowAddForm(!showAddForm)}
              style={{ padding: '8px 16px', background: '#7C3AED', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}
            >
              {showAddForm ? 'Cancel' : '+ Add Intern'}
            </button>
          </div>
        </div>

        {/* Add Agent Form */}
        {showAddForm && (
          <div className="card" style={{ marginTop: '12px' }}>
            <h3 style={{ margin: '0 0 16px', fontSize: '16px' }}>Add New Intern / Ambassador</h3>
            <form onSubmit={handleAddAgent}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label style={labelStyle}>Name *</label>
                  <input type="text" value={newAgent.name} onChange={e => setNewAgent(p => ({ ...p, name: e.target.value }))} placeholder="e.g. Priya" style={inputStyle} required />
                </div>
                <div>
                  <label style={labelStyle}>Email *</label>
                  <input type="email" value={newAgent.email} onChange={e => setNewAgent(p => ({ ...p, email: e.target.value }))} placeholder="priya@email.com" style={inputStyle} required />
                  <small style={{ color: '#6b7280', fontSize: '11px' }}>They'll receive their link + signup notifications here</small>
                </div>
                <div>
                  <label style={labelStyle}>Referral Code *</label>
                  <input type="text" value={newAgent.referralCode} onChange={e => setNewAgent(p => ({ ...p, referralCode: e.target.value.toLowerCase().replace(/[^a-z0-9-_]/g, '') }))} placeholder="e.g. priya-2025" style={inputStyle} required maxLength={20} />
                  <small style={{ color: '#6b7280', fontSize: '11px' }}>3-20 chars, letters/numbers/hyphens only</small>
                </div>
                <div>
                  <label style={labelStyle}>Notes</label>
                  <input type="text" value={newAgent.notes} onChange={e => setNewAgent(p => ({ ...p, notes: e.target.value }))} placeholder="e.g. College campus ambassador" style={inputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>Country *</label>
                  <select value={newAgent.country} onChange={e => setNewAgent(p => ({ ...p, country: e.target.value }))} style={inputStyle}>
                    <option value="India">India ($25/100 users, $50 bonus at 500)</option>
                    <option value="US">US/Other ($50/100 users, $100 bonus at 500)</option>
                  </select>
                </div>
              </div>
              {error && <p style={{ color: '#dc2626', fontSize: '13px', marginTop: '8px' }}>{error}</p>}
              <button type="submit" style={{ marginTop: '16px', padding: '10px 24px', background: '#7C3AED', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}>
                Create Agent
              </button>
            </form>
          </div>
        )}

        {/* Summary Metrics */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '12px', marginTop: '16px' }}>
          <MetricCard label="Total Signups" value={totals.signups} color="#7C3AED" />
          <MetricCard label="Activated" value={totals.activated} color="#059669" />
          <MetricCard label="First Post" value={totals.posted} color="#2563eb" />
          <MetricCard label="7-Day Retained" value={totals.retained} color="#d97706" />
        </div>

        {/* Filter */}
        <div className="card" style={{ marginTop: '16px', display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
          <span style={{ fontSize: '13px', color: '#6b7280', fontWeight: '500' }}>Filter:</span>
          {['', '7', '30', '90'].map(d => (
            <button key={d} onClick={() => setDaysFilter(d)} style={{
              padding: '4px 12px', borderRadius: '16px', border: '1px solid #e5e7eb', fontSize: '12px', cursor: 'pointer',
              background: daysFilter === d ? '#7C3AED' : '#fff', color: daysFilter === d ? '#fff' : '#374151', fontWeight: '500'
            }}>
              {d === '' ? 'All time' : `Last ${d} days`}
            </button>
          ))}
        </div>

        {/* Agent Table */}
        {loading ? (
          <div className="card" style={{ marginTop: '16px', textAlign: 'center', color: '#6b7280' }}>Loading...</div>
        ) : agents.length === 0 ? (
          <div className="card" style={{ marginTop: '16px', textAlign: 'center' }}>
            <p style={{ fontSize: '48px', margin: '0 0 12px' }}>👥</p>
            <p style={{ color: '#6b7280' }}>No referral agents yet. Add your first intern above.</p>
          </div>
        ) : (
          <div className="card" style={{ marginTop: '16px', padding: 0, overflow: 'hidden' }}>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                <thead>
                  <tr style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                    <th style={thStyle}>Intern</th>
                    <th style={thStyle}>Code</th>
                    <th style={thStyle}>Rate</th>
                    <th style={thStyle}>Signups</th>
                    <th style={thStyle}>Activated</th>
                    <th style={thStyle}>Posted</th>
                    <th style={thStyle}>Retained 7d</th>
                    <th style={thStyle}>Earned</th>
                    <th style={thStyle}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {agents.map(agent => {
                    const isIndia = (agent.country || '').toLowerCase() === 'india' || (agent.country || '').toLowerCase() === 'in';
                    const perHundred = isIndia ? 25 : 50;
                    const bonus500 = isIndia ? 50 : 100;
                    const earned = Math.floor(agent.total_signups / 100) * perHundred + (agent.total_signups >= 500 ? bonus500 : 0);
                    return (
                      <tr key={agent.agent_id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                        <td style={tdStyle}>
                          <div style={{ fontWeight: '600' }}>{agent.name}</div>
                          {agent.email && <div style={{ fontSize: '11px', color: '#9ca3af' }}>{agent.email}</div>}
                        </td>
                        <td style={tdStyle}>
                          <code style={{ background: '#f3f4f6', padding: '2px 6px', borderRadius: '4px', fontSize: '12px' }}>{agent.referral_code}</code>
                          <div style={{ fontSize: '10px', color: '#9ca3af', marginTop: '2px' }}>
                            {siteUrl}/register?ref={agent.referral_code}
                          </div>
                        </td>
                        <td style={tdStyle}>
                          <span style={{ fontSize: '11px', background: isIndia ? '#fef3c7' : '#dbeafe', padding: '2px 6px', borderRadius: '4px' }}>
                            {isIndia ? '🇮🇳 $25' : '🌍 $50'}/100
                          </span>
                        </td>
                        <td style={{ ...tdStyle, fontWeight: '700', color: '#7C3AED' }}>{agent.total_signups}</td>
                        <td style={{ ...tdStyle, color: '#059669' }}>{agent.activated_users}</td>
                        <td style={{ ...tdStyle, color: '#2563eb' }}>{agent.users_with_posts}</td>
                        <td style={{ ...tdStyle, color: '#d97706' }}>{agent.retained_7d_users}</td>
                        <td style={{ ...tdStyle, fontWeight: '600', color: '#059669' }}>${earned}</td>
                        <td style={tdStyle}>
                          <button
                            onClick={() => handleToggleActive(agent.agent_id, agent.is_active)}
                            style={{
                              padding: '3px 10px', borderRadius: '12px', border: 'none', fontSize: '11px', fontWeight: '600', cursor: 'pointer',
                              background: agent.is_active ? '#dcfce7' : '#fee2e2',
                              color: agent.is_active ? '#166534' : '#991b1b',
                            }}
                          >
                            {agent.is_active ? 'Active' : 'Inactive'}
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* How it works */}
        <div className="card" style={{ marginTop: '16px' }}>
          <h3 style={{ margin: '0 0 12px', fontSize: '15px' }}>How Referral Attribution Works</h3>
          <ol style={{ margin: 0, paddingLeft: '20px', fontSize: '13px', color: '#555', lineHeight: '2' }}>
            <li>Create an intern with a unique referral code (e.g. <code>priya-2025</code>)</li>
            <li>Give them their link: <code>{siteUrl}/register?ref=CODE</code></li>
            <li>When users sign up via that link, the signup is attributed to the intern</li>
            <li><strong>Activated</strong> = user selected at least 1 identity</li>
            <li><strong>Posted</strong> = user made at least 1 post in any space</li>
            <li><strong>Retained 7d</strong> = user was active 7+ days after signup</li>
          </ol>
        </div>
      </div>
    </div>
  );
}

function MetricCard({ label, value, color }) {
  return (
    <div className="card" style={{ textAlign: 'center', padding: '16px' }}>
      <div style={{ fontSize: '24px', fontWeight: '700', color }}>{value}</div>
      <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>{label}</div>
    </div>
  );
}

const labelStyle = { display: 'block', fontSize: '13px', fontWeight: '600', color: '#374151', marginBottom: '4px' };
const inputStyle = { width: '100%', padding: '8px 12px', fontSize: '14px', border: '1px solid #d1d5db', borderRadius: '8px', boxSizing: 'border-box' };
const thStyle = { padding: '10px 12px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: '#6b7280' };
const tdStyle = { padding: '10px 12px' };

export default AdminReferrals;
